/** Shared constants and validation for the auth surface (AITS-498). */

/** Same shape the aits-2.0 prototype validates with. */
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Plain-language email check, worded as the handoff specifies. Returns the
 * message to show, or null when the address is usable.
 *
 * Shared so sign in / create account / forgot password cannot drift apart —
 * all three show the user the same words for the same mistake.
 */
export function getEmailError(value: string): string | null {
    const v = value.trim();
    if (!v) return "Type your email address first.";
    if (!EMAIL_RE.test(v)) {
        return "That doesn't look like an email address. Check it and try again.";
    }
    return null;
}

export const SUPPORT_EMAIL = "care@aitrustsignals.com";

export const CONTACT_URL = "https://www.aitrustsignals.com/contact";

export const getLoginNotice = (reason: string | null): string | null =>
    reason === "session_expired"
        ? "Your session expired. Sign in again to continue."
        : null;

/** Backend minimum, mirrored so the field can say so before the round trip. */
export const MIN_PASSWORD_LENGTH = 8;

/**
 * What the server actually enforces (accounts.validators.PasswordComplexityValidator
 * + Django's MinimumLengthValidator, wired in config/settings/base.py).
 *
 * Shown as a hint rather than re-implemented as a client check: duplicating the
 * rules here would drift from the backend. The length check runs client-side
 * because it is stable and catches the common case; everything else is caught
 * server-side and surfaced verbatim.
 */
export const PASSWORD_RULE =
    "At least 8 characters, with an upper and lower case letter, a number, and a symbol.";
